import { useTranslations } from "@/lib/useTranslations";
import { EditorialChecklistItems } from "@/components/ui/admin/EditorialChecklistItems";
import {
  getEventEditorialChecklist,
  type EventEditor,
} from "@/core/services/types/event.types";

type EventEditorialChecklistFields = Pick<
  EventEditor,
  | "cover_image_url"
  | "place_id"
  | "title"
  | "description_short"
  | "description_long"
  | "event_category"
  | "start_date"
  | "end_date"
>;

type EventEditorialChecklistProps = {
  event: EventEditorialChecklistFields;
  placeName?: string | null;
};

export function EventEditorialChecklist({
  event,
  placeName = null,
}: EventEditorialChecklistProps) {
  const t = useTranslations("events.edit");
  const checklist = getEventEditorialChecklist(event);
  const placeLabel =
    checklist.hasPlace && placeName?.trim()
      ? t("checklistPlaceWithName", { name: placeName.trim() })
      : t("checklistPlace");

  const items = [
    { checked: checklist.hasCoverImage, label: t("checklistImage") },
    { checked: checklist.hasPlace, label: placeLabel },
    {
      checked: checklist.hasTitleAndDescription,
      label: t("checklistTitleAndDescription"),
    },
  ];

  if (checklist.requiresDates) {
    items.push({
      checked: checklist.hasDates,
      label: t("checklistDates"),
    });
  }

  return (
    <section className="wireframe-border bg-white p-5">
      <EditorialChecklistItems
        showLabel={false}
        className="space-y-3"
        items={items}
      />
    </section>
  );
}
